<div class="skeleton-cell p-16">
  <div class="loading-bar">
    <div class="loading-bar-fill"></div>
  </div>
</div>
